import { Icon } from "@material-ui/core";
import HorizontalCard from "Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCard";
import * as React from "react";
import Dropzone from "react-dropzone";
import i18n from "Translations/i18n";
import styles from "./HorizontalCardAddItem.scss";


interface IProps {
    addItem: () => void;
    descriptionFileUpdated?: (file: File) => void;
    style?: React.CSSProperties;
    addItemText?: string;
}

export class HorizontalCardAddItem extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);

        this.onDrop = this.onDrop.bind(this);
    }

    public onDrop(files: File[]) {
        if (files && files.length > 0 && this.props.descriptionFileUpdated) {
            this.props.descriptionFileUpdated(files[0]);
        }
    }

    public render() {
        return (
            <HorizontalCard className={styles.horizontalCardAddItem} style={this.props.style}>
                <div className={styles.cardSizer}>
                    <div className={styles.cardContent}>
                        <div id="divAddNewInstruction" className={styles.addWrapper} onClick={this.props.addItem}>
                            <span className={styles.icon}><Icon>add</Icon></span>
                            <span>{this.props.addItemText || i18n.t("common.addNewInstruction")}</span>
                        </div>
                        {this.props.descriptionFileUpdated &&
                            <>
                                <div className={styles.orLine}>
                                    <span>{i18n.t("common.or")}</span>
                                </div>
                                <div className={styles.addWrapper}>
                                    <Dropzone
                                        accept={"application/pdf"}
                                        onDrop={files => this.onDrop(files)}
                                        multiple={false}
                                    >
                                        {({ getRootProps, getInputProps, isDragAccept, isDragReject }) => (
                                            <div {...getRootProps()} className={`${styles.dropzone} ${isDragAccept ? styles.dragAccept : null} ${isDragReject ? styles.dragReject : null}`}>
                                                <input {...getInputProps()} />
                                                <span className={styles.icon}><Icon>add</Icon></span>
                                                <span>{i18n.t("common.addPdf")}</span>
                                            </div>
                                        )}
                                    </Dropzone>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </HorizontalCard>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardAddItem/HorizontalCardAddItem.tsx